export const OPEN_TASK_MANAGEMENT_TRANSACTION = 'TASK_MANAGEMENT.OPEN_TASK_MANAGEMENT_TRANSACTION';
export const PANEL_MENU_ITEM_CLICKED = 'TASK_MANAGEMENT.PANEL_MENU_ITEM_CLICKED';
export const SET_ACTIVE_PANEL_GUID = 'TASK_MANAGEMENT.SET_ACTIVE_PANEL_GUID';

export const ON_GET_TASKS = 'TASK_MANAGEMENT.ON_GET_TASKS';

export const SET_FROM_TRANSFER_TYPE = 'TASK_MANAGEMENT.SET_FROM_TRANSFER_TYPE';
export const SET_USERS_DOING_THE_TASK = 'TASK_MANAGEMENT.SET_USERS_DOING_THE_TASK';
export const SET_POSITIONS_DOING_THE_TASK = 'TASK_MANAGEMENT.SET_POSITIONS_DOING_THE_TASK';
export const SET_TASKS = 'TASK_MANAGEMENT.SET_TASKS';
export const SET_SELECTED_TASK = 'TASK_MANAGEMENT.SET_SELECTED_TASK';

export const SET_TO_TRANSFER_TYPE = 'TASK_MANAGEMENT.SET_TO_TRANSFER_TYPE';
export const SET_USER_TO_DO_THE_TASK = 'TASK_MANAGEMENT.SET_USER_TO_DO_THE_TASK';
export const SET_POSITION_TO_DO_THE_TASK = 'TASK_MANAGEMENT.SET_POSITION_TO_DO_THE_TASK';

export const SET_PROCESS_ITEMS = 'TASK_MANAGEMENT.SET_PROCESS_ITEMS';
export const SET_SELECTED_PROCESS_ITEMS = 'TASK_MANAGEMENT.SET_SELECTED_PROCESS_ITEMS';

export const SET_FILTER_LOADING = 'TASK_MANAGEMENT.SET_FILTER_LOADING';
export const TRANSFER_PROCESS_ITEMS = 'TASK_MANAGEMENT.TRANSFER_PROCESS_ITEMS';

export const DECREASE_COUNT = 'TASK_MANAGEMENT.DECREASE_COUNT';
